import { useSelector } from 'react-redux';
import { ClaimSliceData } from '../reducers/claimSlice/claimSlice';

const useClaimData = (): ClaimSliceData => {
    return useSelector(({ claim }: PersistedStore) => claim);
};

export default useClaimData;
